import React, { useEffect, useRef, useState } from 'react'
import Button from '@mui/material/Button';
import { useFormik } from "formik";
import * as Yup from "yup";
import { Box, Checkbox, Chip, Dialog, DialogActions, DialogContent, Divider, FormControl, FormControlLabel, FormHelperText, IconButton, InputLabel, ListItemText, MenuItem, Select, TextField, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';
import FileUploader from '../Common/FileUploader';
import { CloseRounded } from '@mui/icons-material';
import { fetchDomains, fetchLocations, importDomain } from '../../store/domainSlice';
import { fetchIndustries, fetchIndustryList } from '../../store/industrySlice';

export default function FilterDomain({ filterOpen, setfilterOpen, setPage, page, ordering, rowsPerPage, fetchDomainsDetails, setQueryString, setisfilter }) {
    const dispatch = useDispatch();
    const [selectedIndustry, setSelectedIndustry] = React.useState(0);
    const [filterChanged, setfilterChanged] = React.useState(false);
    const [formValues, setFormValues] = React.useState({
        industry_id: "",
        location_ids: [],
    }); // State to preserve form values
    const industries = useSelector((state) => state.industryReducer.industryList);
    const fbLocations = useSelector((state) => state.domainReducer.fbLocations);

    const allOptionId = "all";
    const allOptionLabel = "All";
    const allLocationIds = fbLocations?.map((ele) => ele.id);

    const validationSchema = Yup.object({
        industry_id: Yup.string().required("Client is required"),
        media: Yup.mixed(),
    });

    const handleApply = async () => {
        const values = formik.values;
        const locations =
            (values?.location_ids?.length > 0 &&
                values?.location_ids?.filter((ele) => ele !== allOptionId)) ||
            [];
        let queryString = `?page=1&page_size=${rowsPerPage}&ordering=${ordering || ""}`;

        setPage(0)
        if (selectedIndustry) {
            queryString += `&industry_ids=${selectedIndustry}`;
        }

        if (locations.length > 0) {
            queryString += `&location_ids=${locations.join(",")}`; // this keeps commas unencoded
        }
        console.log("setting33333333333");
        console.log("queryString in Apply", queryString);
        setisfilter(true)
        setQueryString(queryString)
        setfilterOpen(false);
        //    await fetchDomainsDetails();
    };

    const formik = useFormik({
        initialValues: formValues, // Use preserved values
        enableReinitialize: true, // Allow reinitialization when `formValues` changes
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            console.log("sumbit");

            setFormValues(values); // Save form values when submitting
            // await handleApply();
        },
    });

    useEffect(() => {
        if (!filterOpen) {
            setFormValues(formik.values); // Save form values when drawer is closed
        }
    }, [filterOpen]);

    // useEffect(() => {
    //     dispatch(fetchIndustryList());
    //     dispatch(fetchLocations());
    // }, []);

    return (
        <Box className="p-3 position-relative h-100">
            <form onSubmit={formik.handleSubmit}>
                <Box className="d-flex justify-content-between">
                    <Typography variant="h6" gutterBottom>
                        Apply Filters
                    </Typography>
                    <Button
                        variant="outlined"
                        className="mb-2"
                        startIcon={<RestartAltIcon color="primary" />}
                        onClick={() => {
                            formik.resetForm();
                            setSelectedIndustry(0);
                            formik.setFieldValue("location_ids", []);
                            dispatch(
                                fetchDomains(
                                    `?page=1&page_size=${rowsPerPage}&ordering=${ordering || ""}`
                                )
                            )
                                .then((res) => {
                                    console.log("domains res dara", res);
                                })
                                .catch((err) => {
                                    console.log("error in fetching lead data", err);
                                });
                            setPage(0)
                            setfilterOpen(false);
                        }}
                    >
                        Clear Filters
                    </Button>
                </Box>
                <Divider />
                <Box
                    sx={{ mt: 4, display: "flex", flexDirection: "column", gap: 2 }}
                    className="mb-3"
                >
                    <FormControl fullWidth>
                        <InputLabel id="industry_id">Industry</InputLabel>
                        <Select
                            labelId="industry_id"
                            id="industry_id"
                            name="industry_id"
                            label="Industry"
                            value={formik.values.industry_id || 0}
                            onChange={(e) => {
                                formik.setFieldValue("industry_id", e.target.value);
                                setfilterChanged(true)
                                setSelectedIndustry(e.target.value);
                                setPage(0);
                            }}
                            endAdornment={
                                selectedIndustry ? (
                                    <IconButton
                                        size="small"
                                        className="mr-4"
                                        onClick={() => {
                                            formik.setFieldValue("industry_id", "");
                                            setSelectedIndustry(0);
                                        }}
                                        onMouseDown={(event) => event.stopPropagation()}
                                    >
                                        <CloseRounded />
                                    </IconButton>
                                ) : null
                            }
                            MenuProps={{
                                PaperProps: { className: "mui-select-menu" },
                            }}
                        >
                            <MenuItem value={0}>All</MenuItem>
                            {(!industries || industries?.length === 0) && (
                                    <MenuItem disabled color="primary">
                                        No Industry found.
                                    </MenuItem>
                                )}
                            {industries?.length > 0 &&
                                industries.map((ele) => (
                                    <MenuItem key={ele.id} value={ele.id}>
                                        {ele.title}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>

                    <FormControl
                        fullWidth
                        className="mt-1 mb-1 location-select-wrapper"
                        error={formik.touched.location_ids && Boolean(formik.errors.location_ids)}
                    >
                        <InputLabel id="location_ids">Location</InputLabel>
                        <Select
                            labelId="location_ids"
                            id="location_ids"
                            name="location_ids"
                            label="Location"
                            className=""
                            multiple
                            value={formik.values.location_ids || []} // must stay array
                            onChange={(event) => {
                                const value = event.target.value;
                                setfilterChanged(true)
                                const isAllSelected = formik?.values?.location_ids?.includes(allOptionId);
                                const justClickedAll = value.includes(allOptionId) && !isAllSelected;
                                const justUnclickedAll = !value.includes(allOptionId) && isAllSelected;

                                if (justClickedAll) {
                                    formik.setFieldValue("location_ids", [allOptionId, ...allLocationIds]);
                                } else if (justUnclickedAll) {
                                    formik.setFieldValue("location_ids", []);
                                } else {
                                    const filtered = value.filter((val) => val !== allOptionId);

                                    if (filtered?.length === allLocationIds?.length) {
                                        formik.setFieldValue("location_ids", [allOptionId, ...filtered]);
                                    } else {
                                        formik.setFieldValue("location_ids", filtered);
                                    }
                                }
                            }}
                            MenuProps={{
                                PaperProps: {
                                    className: "mui-select-menu",
                                },
                            }}
                            onBlur={formik.handleBlur}
                            renderValue={(selected) => {
                                if (selected.length === 0) {
                                    return (
                                        <Typography color="textSecondary">Select locations</Typography>
                                    );
                                } else {
                                    return (
                                        <Box
                                            sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}
                                            className="multi-selection-box-wrapper"
                                        >
                                            {selected?.map((id) => {
                                                const location = fbLocations?.find((ele) => ele.id === id);
                                                return (
                                                    location && (
                                                        <Chip
                                                            key={id}
                                                            label={location?.display_name || id}
                                                            onMouseDown={(e) => e.stopPropagation()}
                                                            onDelete={() => {
                                                                const newSelected =
                                                                    formik.values.location_ids.filter(
                                                                        (item) => item !== id && item !== "all"
                                                                    );
                                                                formik.setFieldValue("location_ids", newSelected);
                                                            }}
                                                            className="role-permission mr-2"
                                                        />
                                                    )
                                                );
                                            })}
                                        </Box>
                                    );
                                }
                            }}
                        >
                            
                            <MenuItem key={allOptionId} value={allOptionId}>
                                <Checkbox
                                    checked={formik.values.location_ids?.includes(allOptionId)}
                                />
                                <ListItemText primary={allOptionLabel} />
                            </MenuItem>
                            {fbLocations?.length > 0 &&
                                fbLocations?.map((ele) => (
                                    <MenuItem key={ele.id} value={ele.id}>
                                        <Checkbox
                                            checked={formik.values.location_ids.includes(ele.id)}
                                        />
                                        <ListItemText primary={ele.display_name} />
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </Box>

                <Box className="drawer-footer m-3">
                    <Button
                        type="button"
                        variant="outlined"
                        color="primary"
                        onClick={() => setfilterOpen(false)}
                        className="mt-2 mr-2"
                    >
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                        className="mt-2 mr-2"
                        disabled={!filterChanged}
                        onClick={() => {
                            handleApply();
                        }}
                    >
                        Apply
                    </Button>
                </Box>
            </form>
        </Box>
    );
}